module.exports = __webpack_public_path__ + "img/star.d8b2aaa6.png";